import { aiAgentErrorMessage } from '../aiAgentErrorCode'

import { buildSseWireText } from './sseWireFormat'

// assistant.error を伴わず、result だけが異常終了（subtype: 'error_max_turns'）するケースのSSEフィクスチャ。
// billingErrorSse と異なり、error イベントは result 到達時に初めて生成される
export const maxTurnsErrorSse: string = buildSseWireText([
  { type: 'error', message: aiAgentErrorMessage('AI-0011'), code: 'AI-0011' },
  {
    type: 'done',
    usage: { inputTokens: 100, outputTokens: 50 },
    costUsd: 0.02,
    isError: true,
    durationMs: 1000,
    durationApiMs: 800,
    numTurns: 20,
    errorCode: 'AI-0011',
  },
])
